module.exports = "/addons/yumi_dianqun/template/mobile/img/logo.png";